import {
  Component,
  Input,
  ChangeDetectionStrategy,
  SimpleChanges,
  OnChanges,
  Output, EventEmitter
} from '@angular/core';
import { AnticipatedExpendituresComponent, FinancialHealthReport } from '../../../reports/shared/models';
import { ReportColors } from '../../../shared/constants';

@Component({
  selector: 'sp-dashboard-current-display',
  templateUrl: './dashboard-current-display.component.html',
  styleUrls: ['./dashboard-current-display.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DashboardCurrentDisplayComponent implements OnChanges {
  @Input() reportData: FinancialHealthReport;
  @Output() backToDashboard: EventEmitter<void> = new EventEmitter<void>();

  chartData: { name: string, value: number }[] = [];

  dxPieChartPalette = ReportColors;

  hasNoComponents = true;
  selectedCategory = '';
  selectedAnticipatedExpenditures: AnticipatedExpendituresComponent[];
  selectedCategoryComponents: AnticipatedExpendituresComponent[];
  selectedYear: string;
  totalCurrentReplacementCost: number;
  totalAnticipatedExpenditures: number;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['reportData'] && this.reportData) {
      const componentInventoryReport = this.reportData.componentInventoryReport;
      if (componentInventoryReport.categories && componentInventoryReport.categories.length > 0) {
        this.updateComponentInventoryChart();
        this.hasNoComponents = false;
      }
    }
  }

  selectCategory(e: any) {
    const categoryName = e?.target?.data?.name;
    if (!this.reportData.isDataTruncated && categoryName) {
      this.showCategoryComponents(this.removePercentFromCategory(categoryName));
      this.scrollTo('category-components');
    }
  }

  selectYear(year: string) {
    if (!this.reportData.isDataTruncated && year) {
      this.showAnticipatedExpenditures(year);
      this.scrollTo('anticipated-expenditures');
    }
  }

  setBackTo() {
    this.backToDashboard.emit();
  }

  customizeDxPieChartLabel(arg) {
    return arg?.argumentText.replace(/\d+(?:\.\d+)?%/g, '').trim();
  }

  hoveredOnPieSlice(e: any) {
    if (e.target.isHovered()) {
      e.element.style.cursor = 'pointer';
    } else {
      e.element.style.cursor = 'auto';
    }
  }

   
  displayYearsDropdownChanged() {
    // This is odd, but this was basically needed to force the Funding Chart to refresh.  
  }

  private removePercentFromCategory(val) {
    return val.replace(/\d+(?:\.\d+)?%/g, '').trim();
  }

  private scrollTo(fragment: string) {
    const element = document.getElementById(fragment);
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    element.scrollTop -= 80;
  }

  private showCategoryComponents(categoryName: string) {

    this.selectedCategory = categoryName;
    this.selectedCategoryComponents = [];
    this.reportData.componentInventoryReport.categories
      .filter(x => x.name === categoryName)
      .forEach(x => x.propertyComponents.forEach(y => this.selectedCategoryComponents.push(<AnticipatedExpendituresComponent>y)));

    this.totalCurrentReplacementCost = this.selectedCategoryComponents.reduce((a, b) => a + b.currentReplacementCost, 0);
    this.totalAnticipatedExpenditures = this.selectedCategoryComponents.reduce((a, b) => a + b.anticipatedExpenditures, 0);
  }

  private showAnticipatedExpenditures(year: string) {

    this.selectedYear = year;
    this.selectedAnticipatedExpenditures = [];
    this.reportData.anticipatedExpendituresReport.anticipatedExpenditureYears
      .filter(x => x.name === year)
      .forEach(x => x.propertyComponents
        .forEach(y => this.selectedAnticipatedExpenditures.push(y)));

    this.totalCurrentReplacementCost = this.selectedAnticipatedExpenditures.reduce((a, b) => a + b.currentReplacementCost, 0);
    this.totalAnticipatedExpenditures = this.selectedAnticipatedExpenditures.reduce((a, b) => a + b.anticipatedExpenditures, 0);
  }

  private updateComponentInventoryChart() {
    if (this.reportData && this.reportData.componentInventoryReport) {
      const totalCost = this.reportData.componentInventoryReport.categories.reduce((a, b) => a + b.totalCurrentReplacementCost, 0);

      this.chartData = this.reportData.componentInventoryReport.categories.map(item => {
        return {
          name: item.name + ' ' + Number((item.totalCurrentReplacementCost / totalCost) * 100).toFixed(1) + '%',
          value: item.totalCurrentReplacementCost
        };
      });

      // Sort by cost, descending
      this.chartData.sort((x, y) => {
        if (x.value > y.value) { return -1; }
        if (x.value < y.value) { return 1; }
        return -0;
      });
    }
  }
}
